import React from "react";
import { ROLE_DISPLAY_NAMES, ROLE_BADGE_COLORS } from "../constants";

const RoleBadge = ({ role, size = "sm" }) => {
  if (!role) return null;

  const displayName = ROLE_DISPLAY_NAMES[role] || role;
  const colors =
    ROLE_BADGE_COLORS[role] || "bg-gray-100 text-gray-800 border-gray-200";

  const sizeClasses = {
    xs: "px-1.5 py-0.5 text-xs",
    sm: "px-2 py-1 text-xs",
    md: "px-2.5 py-1.5 text-sm",
    lg: "px-3 py-2 text-sm",
  };

  return (
    <span
      className={`inline-flex items-center rounded-full border font-medium ${colors} ${sizeClasses[size]}`}
    >
      {displayName}
    </span>
  );
};

export default RoleBadge;
